export default __webpack_public_path__ + "static/media/white_instagram.22f32040.png";